/**
 * The id of the body-level element the schedule modal's date picker renders its calendar into.
 * The modal clips its popup and scrolls its body, so an inline calendar would be cut off; the
 * portal escapes that overflow while the popper stays anchored to the input.
 */
export const DATE_PICKER_PORTAL_ID = 'automation-date-picker-portal';
